<template>
  <div class="Management__wrap">
    <div class="management">
      <div class="management__title">윤리경영</div>
      <div class="management__content">
        투명한 경영으로<span class="strong">글로벌 가상자산 거래소</span
        >의<br />
        <span class="strong">신흥 강자로</span> 성장하고자 합니다
      </div>
    </div>
    <div class="explainWrap">
      <div class="explain" v-for="item in explain.content" :key="item.index">
        {{ item }}
      </div>
    </div>
    <div class="lightGrey One">
      한국디지털거래소 윤리강령
      <div class="greyCircle">고객에 대한 다짐</div>
      <div class="circleWrap" v-for="item in customer" :key="item.index">
        <div class="circle" :style="{ 'background-color': item.color }">
          <img class="circleImg" :src="item.img" />
        </div>
        <div class="circleTitle" v-html="item.title"></div>
        <div class="circleContent" v-html="item.content"></div>
      </div>
    </div>
    <div class="grey">
      <div class="greyCircle">국가와 사회에 대한 다짐</div>
      <div class="borderSquareWrap">
        <div
          class="borderSquare"
          v-for="item in countrySociety"
          :key="item.index"
        >
          <img class="promiseImg" :src="item.img" />
          <div class="promiseTitle">{{ item.title }}</div>
          <div class="promiseContent">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="lightGrey Two">
      <div class="greyCircle">우리의 다짐</div>
      <div class="row" v-for="item in promise" :key="item.index">
        <img class="rowImage" :src="item.img" />
        <div class="content">
          <div class="contentTitle" v-html="nl2br(item.title)"></div>
          <div class="contentContent" v-html="nl2br(item.content)"></div>
        </div>
      </div>
    </div>
    <div class="whiteBoxWrap">
      <div class="whiteBox">
        <div class="violation">
          <div class="violationTitle">
            <img
              class="infoImg"
              src="~@/assets/img/management/Caution_ic.png"
            />윤리강령 위반 신고처
          </div>
          <div
            class="violationContent"
            v-for="item in violation"
            :key="item.index"
          >
            <img class="infoImg" :src="item.img" />
            <div v-if="item.type === 'email'">
              <span>이메일</span>
              <a :href="`mailto:${item.content}`">{{ item.content }}</a>
            </div>
            <div v-else v-html="item.content"></div>
          </div>
        </div>

        <div class="corruption">
          <div class="corruptionTitle">
            <img
              class="infoImg"
              src="~@/assets/img/management/Caution_ic.png"
            />부정비리 제보 접수처
          </div>
          <div
            class="corruptionContent"
            v-for="item in corruption"
            :key="item.index"
          >
            <img class="infoImg" :src="item.img" />
            <div v-if="item.type === 'email'">
              <span>이메일</span>
              <a :href="`mailto:${item.content}`">{{ item.content }}</a>
            </div>
            <div v-else v-html="item.content"></div>
          </div>
        </div>

        <div class="protect">
          <div class="protectTitle">
            <img
              class="infoImg"
              src="~@/assets/img/management/Caution_ic.png"
            />제보자 보호
          </div>
          <div class="wrap">보호대상</div>

          <div class="protectContent One">
            제보자의 보호는 실명 및 정확한 증거 제출의 경우를 원칙으로 하고
            있습니다.또한 제보자 및 관련 이해관계자 들에 대한 제보 정보도 철저히
            보호될 것입니다.
          </div>
          <div class="protectContent Two">
            제보자에 대한 보호 사항은 다음과 같습니다. <br />- 제보자 신고<br />
            - 제보자가 제시한 증거
          </div>
        </div>

        <div class="policyGreyWrap">
          <div class="policyGreytitle">보호정책</div>
          <div class="policyGreyContent">
            제보자 및 제보 내용은 대외비로 엄격히 처리되며, 제보 시스템은 안전한
            보안체계로 보호되고 있습니다. 또한 제보 담당은 제보에 대한 비밀
            준수를 엄수하는 동시에 서약에 동의한 제한 인원에 의해 운영되고
            있습니다.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Management",
  data: function() {
    return {
      explain: {
        content: [
          "한국디지털거래소는 고객에게 신뢰받고 기술적 강점을 가진 가상자산 거래소로서, 끊임없는 도전과 혁신을 선도하고 고객에게 최고의 서비스를 제공하기 위해 총력을 기울이고 있습니다.",
          "가상자산 산업 발전에 공헌해 나가기 위해서는 신뢰받는 윤리경영을 바탕으로 우리의 생존기반인 고객, 주주, 임직원, 국가와 사회 등 모든 이해관계자들에 대한 사회적 책임을 이행하는데 초점을 맞추고 국가경제와 사회 발전에 기여하고자 합니다.",
          "이를 위해 한국디지털거래소의 모든 임직원이 지켜야 할 올바른 판단과 행동의 원칙이 되는 윤리강령을 제정하고 적극 실천함으로써 글로벌 가상자산 거래소의 신흥 강자로 자리 매김할 계획입니다.",
          "기업윤리란 기업의 의사결정이나 행위에 영향을 받는 이해관계자들을 위해 기업이 어떤 의사결정과 행위를 취할 것인가를 판단하는 기준으로 기업의 정책, 조직, 행동에 적용되는 꼭 지켜야 할 도덕적 기준을 말합니다. ",
          "윤리경영이란 좁은 의미로는 CEO부터 종업원에 이르기까지 인간적 행동의 옳고 그름은 물론 선과 악을 구분해주는 판단 기준과 도덕적 가치 기준과 관련된 기업 경영의 의사결정 과정을 뜻합니다.",
        ],
      },
      customer: [
        {
          img: require("../../assets/img/management/Userfirst_ic.png"),
          color: "#8289e2",
          title: "이용자 우선",
          content:
            "회사와 임직원은 항상 가상자산 이용자의 입장에서 생각하고 가상자산 이용자에게 보다 나은 가상자산 서비스를 제공하기 위해 노력하여야 한다.",
        },
        {
          img: require("../../assets/img/management/Userinformationprotection_ic.png"),
          color: "#78aaf0",
          title: "이용자 정보보호",
          content:
            "회사와 임직원은 가상자산업 수행 과정에서 알게 된 가상자산 이용자의 개인정보를 안전하게 보호하고 관리하여야 한다.",
        },
        {
          img: require("../../assets/img/management/User-centeredmanagement_ic.png"),
          color: "#6ed29b",
          title: "이용자 중심의 경영",
          content:
            "회사는 가상자산 이용자의 요구사항을 경영 활동에 반영하도록 노력하며, 가상자산 이용자 보호 및 민원처리 등을 위한 구체적인 프로세스를 정립하고 이에 대한 정보를 이용자에게 제공하여야 한다.",
        },
      ],
      countrySociety: [
        {
          img: require("../../assets/img/management/Socialresponsibility_ic.png"),
          title: "사회적 책임",
          content:
            "회사와 임직원은 4차 산업혁명 시대의 주역임을 인식하고 사회적 책임과 역할을 다하여야 하며, 가상자산 산업을 수행함에 있어 관련 법령 및 규정을 이해하고 준수하여야 한다.",
        },
        {
          img: require("../../assets/img/management/Faith_Sincerity_ic.png"),
          title: "신의, 성실",
          content:
            "회사와 임직원은 가상자산 이용자의 신뢰와 가상자산 사업자로서의 사회적 책임을 가장 중요한 가치관으로 삼고, 신의 성실의 원칙에 입각하여 맡은 업무를 정직하게 수행하여야 한다.",
        },
        {
          img: require("../../assets/img/management/Respectformarketorder_ic.png"),
          title: "시장질서의 존중",
          content:
            "회사와 임직원은 공정하고 자유로운 가상자산 시장 질서를 존중하고, 가상자산 취급에 있어서 시세조종 및 부정거래행위 등 일체의 불공정거래행위를 방지하고 시장 질서 확립에 필요한 의무를 다한다.",
        },
      ],

      promise: [
        {
          img: require("../../assets/img/management/BG.png"),
          title: "업무정보의 보호",
          content:
            "임직원은 업무수행 과정에서 알게 된 회사의 업무 정보를 가상자산의 중개·교환·매매·예치 등의 거래에 이용하거나 타인에게 이용하게 하는 행위를 하여서는 아니 되며, 회사의 업무 정보가 유출되지 않도록 정보보안의 책임과 의무를 다하여야 한다.",
        },
        {
          img: require("../../assets/img/management/BG2.png"),
          title: "사적이익 추구금지",
          content:
            "임직원은 회사의 재산 및 시스템을 부당하게 사용하거나 자신의 지위를 이용하여 사적 이익을 추구하여서는 아니 된다.",
        },
        {
          img: require("../../assets/img/management/Group 7.png"),
          title: "자기혁신",
          content:
            "임직원은 4차 산업혁명의 주역이 될 가상자산 시장 환경 변화에 유연하게 적응하기 위하여 가상자산의 특성을 이해하고 창의적 사고를 바탕으로 끊임없이 자기 혁신에 힘써야 한다.",
        },
      ],

      violation: [
        {
          type: "telephone",
          img: require("../../assets/img/management/phone_ic.png"),
          content: "전화번호 1522-1221  /  팩스 2264-8900",
        },
        {
          type: "email",
          img: require("../../assets/img/management/Email_ic.png"),
          content: "ethics@flybit.com",
        },
        {
          type: "adress",
          img: require("../../assets/img/management/Home_ic.png"),
          content:
            "서울시 서초구 강남대로 527 브랜드칸타워 14층 윤리경영사무 담당자앞",
        },
      ],
      corruption: [
        {
          type: "telephone",
          img: require("../../assets/img/management/phone_ic.png"),
          content: "전화번호 1522-1221  /  팩스 2264-8900",
        },
        {
          type: "email",
          img: require("../../assets/img/management/Email_ic.png"),
          content: "audit@flybit.com",
        },
        {
          type: "adress",
          img: require("../../assets/img/management/Home_ic.png"),
          content: "서울시 서초구 강남대로 527 브랜드칸타워 14층 검사부",
        },
      ],
    };
  },
  methods: {
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
  },
};
</script>
<style lang="scss" scoped>
.Management__wrap {
  width: 100%;
  margin: 0 auto;

  .violationContent,
  .corruptionContent {
    a {
      text-decoration: underline;
    }
  }

  .management {
    background: url("~@/assets/img/management/KV_img.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 152px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &__title {
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      color: #fff;
      margin-bottom: 6px;
    }
    &__content {
      font-size: 14px;
      font-weight: 300;
      text-align: center;
      color: #fff;
      .strong {
        font-weight: bold;
      }
    }
  }
  .explainWrap {
    padding: 30px 16px 28px;
    margin: 0 auto;
    text-align: left;
    word-break: keep-all;
    .explain:last-of-type {
      margin-bottom: 0px;
    }
    .explain {
      margin-bottom: 20px;
      font-size: 13px;
      font-weight: 300;
    }
  }
  .lightGrey {
    margin: 0 auto;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #333;
    background-color: #f2f5f9;
    padding: 30px 16px 60px;
    .greyCircle {
      width: 180px;
      height: 32px;
      border-radius: 22px;
      background-color: rgb(45, 90, 150, 0.05);
      color: #333;
      font-size: 16px;
      font-weight: 500;
      margin: 33px auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .circleWrap {
      margin-bottom: 30px;
      .circle {
        margin: 0 auto;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        .circleImg {
          width: 68px;
          height: 68px;
        }
      }
      .circleTitle {
        text-align: center;
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 10px;
      }

      .circleContent {
        text-align: center;
        font-size: 13px;
        font-weight: 300;
        word-break: keep-all;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .grey {
    margin: 0 auto;
    width: 100%;
    background-color: #edf1f7;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 37px 16px 60px;
    .greyCircle {
      width: 180px;
      height: 32px;
      border-radius: 22px;
      background-color: rgb(45, 90, 150, 0.05);
      color: #333;
      font-size: 16px;
      font-weight: 500;
      margin: 33px auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .borderSquareWrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .borderSquare:last-of-type {
        margin-bottom: 0px;
      }
      .borderSquare {
        align-items: center;
        display: flex;
        flex-direction: column;
        border-radius: 20px;
        box-shadow: 0px 8px 32px 0 rgba(15, 35, 65, 0.05);
        border: solid 2px #aac8f5;
        background-color: #fff;
        height: 306px;
        padding: 35px 15px 60px;
        box-sizing: border-box;
        margin-bottom: 30px;
        .promiseImg {
          width: 78px;
          height: 78px;
        }
        .promiseTitle {
          margin-top: 12px;
          margin-bottom: 12px;
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          color: #333;
        }
        .promiseContent {
          font-size: 13px;
          font-weight: 300;
          text-align: center;
          color: #333;
          word-break: keep-all;
        }
      }
    }
  }

  .lightGrey.Two {
    padding: 30px 16px 60px;
    .row:last-of-type {
      margin-bottom: 0px;
    }
    .row {
      margin: 0 auto;
      margin-bottom: 30px;
      .rowImage {
        border-radius: 10px;
        margin-bottom: 20px;
        width: 100%;
      }
      .content {
        .contentTitle {
          font-size: 13px;
          font-weight: 500;
          margin-bottom: 10px;
        }
        .contentContent {
          font-size: 13px;
          font-weight: 300;
          word-break: keep-all;
        }
      }
    }
  }
  .whiteBoxWrap {
    padding: 53px 16px 80px;
    .whiteBox {
      padding-top: 35px;
      padding-right: 16px;
      padding-left: 16px;
      border-radius: 10px;
      border: solid 1px #000;
      box-sizing: border-box;
      .violation {
        word-break: keep-all;
        display: flex;
        flex-direction: column;
        margin-bottom: 30px;
        .violationTitle {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          text-align: left;
          margin-bottom: 17px;
          display: flex;
          align-items: center;
          .infoImg {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
        }
        .violationContent:last-of-type {
          margin-bottom: 0px;
        }
        .violationContent {
          font-size: 13px;
          color: #333333;
          margin-bottom: 12px;
          display: flex;

          .infoImg {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
        }
      }
      .corruption {
        word-break: keep-all;
        margin-bottom: 30px;
        .corruptionTitle {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          text-align: left;
          margin-bottom: 17px;
          display: flex;
          align-items: center;
          .infoImg {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
        }
        .corruptionContent:last-of-type {
          margin-bottom: 0px;
        }
        .corruptionContent {
          font-size: 13px;
          color: #333333;
          margin-bottom: 12px;
          display: flex;
          .infoImg {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
        }
      }
      .protect {
        margin-bottom: 30px;
        word-break: keep-all;
        .protectTitle {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          text-align: left;
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          .infoImg {
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
        }
        .wrap {
          font-size: 13px;
          color: #333333;
          margin-bottom: 4px;
        }
        .protectContent {
          font-size: 13px;
          color: #333333;
          &.One {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .policyGreyWrap {
    border-radius: 4px;
    color: #333;
    background-color: rgb(202, 206, 213, 0.1);
    padding: 30px 16px 60px;
    margin-left: -16px;
    margin-right: -16px;
    .policyGreytitle {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .policyGreyContent {
      font-size: 13px;
      color: #333333;
    }
  }
}
</style>
